<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <div class="row d-flex flex-row align-items-end">
      <div class="col-md-8">
        <div class="ml-auto" style="max-width: 500px;">
          <h6>Группы заказов</h6>
          <table class="table table-bordered table-sm mb-0 ">
            <thead>
              <tr>
                <th>Группа</th>
                <th>Заказы</th>
                <th>Шт</th>
                <th>Сумма</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, productTypeName) in ordersByTypes">
                <td>{{ productTypeName }}</td>
                <td>{{ item.TotalCount }}</td>
                <td>{{ item.Amount }}</td>
                <td>{{ item.Summary }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Итого</td>
                <td>{{totalOrdersByTypes.TotalCount}}</td>
                <td>{{totalOrdersByTypes.TotalAmount}}</td>
                <td>{{totalOrdersByTypes.Summary}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="col-md-4">
        <div v-if="allowMarking" class="text-right pb-3">
          <button :class="allIsDelivered ? 'btn-success' : 'btn-outline-success'" class="btn ml-2" type="button"
                  @click="allToDelivered">
            Доставлено
          </button>
          <button :class="allIsPaid ? 'btn-success' : 'btn-outline-success'" class="btn ml-2" type="button"
                  @click="allToPaid">Оплачено
          </button>
          <button :class="allIsPassed ? 'btn-success' : 'btn-outline-success'" class="btn ml-2" type="button"
                  @click="allToPassed">Сдано
          </button>
        </div>
        <div class="text-right">
          <button v-if="isUndeliveredOrdersByDateAndTour" class="btn btn-danger ml-2" @click.prevent="print2">Печать
            недоставленных
          </button>
          <button v-if="allowPrinting" class="btn btn-warning ml-2" v-print="'#printMe'">Печать</button>
          <button class="btn btn-secondary ml-2" type="button" @click="$router.go(-1)">Назад</button>
        </div>
      </div>
    </div>


    <div class="alert-info p-3 mt-3">
      <legend>Выбрано заказов: {{ checkedOrders.length }}</legend>
      <div class="d-flex flex-row">
        <div>
          <div>
            <label class="">Выберите статус</label>
          </div>
          <div>
            <button type="button"
                    v-for="status in allowedStatuses"
                    class="btn btn-sm btn-outline-success  mr-3"
                    @click.prevent="setStatus(checkedOrders, status.Code)"
            >{{ status.Name }}
            </button>
          </div>
        </div>
        <div class="ml-md-3">
          <div>
            <label class="">Применить статус счета</label>
          </div>
          <div>
            <button type="button" class="btn btn-sm btn-outline-success"
                    @click.prevent="setBilledStatus(checkedOrders, true)"
            >Счет выставлен
            </button>
            <button type="button" class="btn btn-sm btn-outline-danger ml-3 mr-3"
                    @click.prevent="setBilledStatus(checkedOrders, false)"
            >Счет не выставлен
            </button>
          </div>
        </div>

        <div class="ml-md-3">
          <div>
            <label class="">Применить дату получения</label>
          </div>
          <div>
            <date-picker v-model="allPassedDate"
                         :editable="false"
                         :format="momentFormat"
                         clearButton="false"
                         input-class="form-control form-control-sm"
                         lang="ru"
                         :first-day-of-week="1"
                         placeholder=""
                         style="width: auto;"
                         valueType="format"
                         @input="setPassedDate(checkedOrders, $event)">
            </date-picker>
          </div>
        </div>

      </div>
    </div>


    <div id="printMe" class="mt-3">
      <table class="table table-sm table-borderless">
        <tbody>
          <tr>
            <td>
              Доставка: {{ $route.query.time }}
              <date-picker :editable="false"
                           :format="momentFormat"
                           @input="setDeliveryDate($event)"
                           clearButton="false"
                           input-class="form-control form-control-sm"
                           lang="ru"
                           :first-day-of-week="1"
                           placeholder=""
                           style="width: auto;"
                           v-if="$auth.check(['admin'])"
                           valueType="format">
              </date-picker>
            </td>
            <td>
              <vue-barcode :margin="0" :value="courierBarCode" :width="2" display-value="false" height="20">
                Ошибка штрихкода
              </vue-barcode>
            </td>
            <td>
              Курьер: {{ courier.Mname }} {{ courier.Lname }} {{ courier.Fname }} ({{ courier.Login }})
            </td>
            <td>
              {{ currentDate }}
            </td>
          </tr>
        </tbody>
      </table>

      <table class="table table-bordered table-hover table-sm w-100 table-cell-align-middle">
        <thead>
          <tr class="">
            <th class="d-print-none">
              <input v-model="checkAll" type="checkbox">
            </th>
            <th>Объезд</th>
            <th>Пункт</th>
            <th class="text-right" style="width: 50px;">К-во</th>
            <th v-for="paymentType in $root.paymentTypes" class="text-right" style="width: 50px">
              {{ paymentType.Name }}
            </th>
            <th style="width: 50px" class="text-right">К</th>
            <th width="10" class="d-print-none"></th>
            <th class="d-print-none"></th>
            <th class="d-print-none">Статус счета</th>
            <th class="d-print-none">Дата получения</th>
          </tr>
        </thead>
        <tbody>

          <template v-for="(receptionOrders) in orderListGroupByPoint">
            <template v-for="(order, index) in receptionOrders">
              <template v-if="index === 0">
                <tr class="font-weight-bold">
                  <td class="d-print-none" width="1">
                    <input :checked="fullFilledPoint(order.Point.Id)" type="checkbox"
                           @change="checkByPointId($event, order.Point.Id)">
                  </td>
                  <td>{{ order.Tour.Name }}</td>
                  <td :colspan="$root.paymentTypes.length + 2" width="70">
                    {{ order.Point.Reception }}
                    <span class="badge badge-light font-weight-normal" style="font-size: 100%;">
                    Итого: <span>{{ getReceptionSummary(receptionOrders) }}</span>
                  </span>
                    <router-link v-if="pointDebt[order.Point.Id]"
                                 :to="{ name: 'debt-point-stats', params: { pointId: order.Point.Id }, query: {onlyDelivered: true}}"
                                 target="_blank"
                                 class="badge badge-warning font-weight-normal ml-1"
                                 style="font-size: 100%;">
                      Долг: {{ pointDebt[order.Point.Id] }}
                    </router-link>

                  </td>
                  <td class="d-print-none"></td>
                  <td class="d-print-none"></td>
                  <td class="d-print-none"></td>
                  <td class="d-print-none"></td>
                </tr>
              </template>
              <tr>
                <td class="d-print-none" width="1">
                  <input v-model="checkedOrders" :value="order.Order.Id" type="checkbox">
                </td>
                <td class="text-nowrap overflow-hidden" style="width: 200px; max-width: 200px; text-overflow: ellipsis;">
                  <a :href="`https://sferazakaz.ru/panel/order/${order.Order.UmiId}`" target="_blank">
                  {{ order.Order.RecastNumber > 0 ? 'Переделка заказа ' : '' }} {{ order.Order.SferaNumber }} {{
                    order.Order.LocalNumber && (`/
                ${order.Order.LocalNumber}`)
                  }}</a>
                </td>
                <td class="overflow-hidden text-nowrap" style="max-width: 0; text-overflow: ellipsis;">
                  {{ order.Order.Name }}
                </td>
                <td>
                  {{ order.Order.Amount }}
                </td>
                <td v-for="paymentType in $root.paymentTypes" class="text-right text-nowrap">
                  {{
                    order.Order.PaymentTypeId === paymentType.Id ? (order.Order.Summary ? order.Order.Summary : '') : ''
                  }}
                </td>
                <td class="text-right"><input type="checkbox" v-model="order.IsCardPaid"
                                              @change="checkOrderItemIsCardPaid(order.Order)"></td>
                <td class="d-print-none" width="30">
                  <button class="btn btn-outline-secondary btn-sm" type="button"
                          @click.prevent="deleteDelivery([order.Delivery.Id])">
                    <font-awesome-icon :icon="['far', 'trash-alt']"/>
                  </button>
                </td>
                <td class="d-print-none" width="50">
                  <div class="dropdown">
                    <button id="dropdownMenuButton"
                            :class="statusColor(order.Order.OrderStatusId)"
                            aria-expanded="false" aria-haspopup="true"
                            class="btn dropdown-toggle btn-sm btn-block" data-toggle="dropdown" type="button">
                      {{ getStatusNameById(order.Order.OrderStatusId) }}
                    </button>
                    <div class="dropdown-menu">
                      <h6 class="dropdown-header">Изменить статус</h6>
                      <a v-for="status in allowedStatuses" class="dropdown-item" href="#"
                         @click.prevent="setStatus([order.Order.Id], status.Code)">{{ status.Name }}</a>
                      <h6 class="dropdown-header">Операции</h6>
                      <a class="dropdown-item" href="#" @click.prevent="partPaid(order.Order.Id)">Оплачен частично</a>
                    </div>
                  </div>
                </td>
                <td class="d-print-none" style="" width="170">
                  <div class="dropdown">
                    <button id="dropdownMenuButton"
                            :class="billedStatusColor(order.Order.IsBilled)"
                            aria-expanded="false" aria-haspopup="true"
                            class="btn dropdown-toggle btn-sm btn-block" data-toggle="dropdown" type="button">
                      {{ order.Order.IsBilled ? 'Счет выставлен' : 'Счет не выставлен' }}
                    </button>
                    <div class="dropdown-menu">
                      <h6 class="dropdown-header">Изменить статус</h6>
                      <a class="dropdown-item" href="#"
                         @click.prevent="setBilledStatus([order.Order.Id], true)">Счет выставлен</a>
                      <a class="dropdown-item" href="#"
                         @click.prevent="setBilledStatus([order.Order.Id], false)">Счет не выставлен</a>
                    </div>
                  </div>
                </td>
                <td class="d-print-none" style="" width="170">
                  <div class="d-flex flex-row">
                    <date-picker v-model="order.Order.PassedDate"
                                 :editable="false"
                                 :format="momentFormat"
                                 clearButton="false"
                                 input-class="form-control form-control-sm"
                                 lang="ru"
                                 :first-day-of-week="1"
                                 placeholder=""
                                 style="width: auto;"
                                 valueType="format"
                                 @input="setPassedDate([order.Order.Id], $event)">
                    </date-picker>
                    <button v-tippy
                            class="btn btn-sm btn-outline-info ml-2"
                            content="Назначить текущую дату получения"
                            type="button"
                            @click.prevent="setCurrentPassedDate([order.Order.Id])">
                      <font-awesome-icon :icon="['far', 'calendar-check']"/>
                    </button>
                  </div>
                </td>
<!--                <td class="d-none d-print-table-cell" width="100">-->
                  <!--                <vue-barcode :margin="0" :value="order.Order.SferaNumber" display-value="false" height="20" width="2">-->
                  <!--                  Ошибка штрихкода-->
                  <!--                </vue-barcode>-->
<!--                </td>-->
              </tr>
            </template>
          </template>
        </tbody>
        <tfoot class="font-weight-bold text-right">
          <tr>
            <td class="d-print-none" colspan="4">Итого в доставке</td>
            <td class="d-none d-print-table-cell" colspan="3">Итого в доставке</td>
            <td v-for="PaymentType in $root.paymentTypes">
              {{ totalAmount[PaymentType.Id] || 0 }}
            </td>
            <td></td>
            <td class="d-print-none" colspan="2"></td>
            <td class="d-print-none">{{ totalWithPaidDate }}</td>
            <td class="d-print-none">{{ totalWithPassedDate }}</td>
          </tr>
        </tfoot>
      </table>

      <!--      <undelivered-orders-by-date-and-tour v-if="isUndeliveredOrdersByDateAndTour"-->
      <!--                                           :items="undeliveredOrdersByDateAndTour"-->
      <!--                                           class="d-none d-print-block"></undelivered-orders-by-date-and-tour>-->
    </div>

    <form class="mb-5 mt-3" method="post" @submit.prevent="addOrder">
      <legend>Добавить заказ</legend>
      <div class="form-group">
        <div class="input-group">
          <input ref="inputSferaNumber" v-model="sferaNumber" class="form-control" placeholder="Номер сферы" required
                 type="number">
          <div class="input-group-append">
            <button class="btn btn-outline-secondary" type="submit">Проверить и добавить</button>
          </div>
        </div>
      </div>
    </form>
    <v-dialog/>
    <modals-container/>
  </div>
</template>
<script>
import _ from 'lodash';
import moment from 'moment';
import VueBarcode from 'vue-barcode';
import DatePicker from 'vue2-datepicker';
import PartnerDelivery from '@/admin/modules/Delivery/_components/PartnerDelivery.vue';
import ReceptionHeadTr from '@/admin/modules/Delivery/_components/ReceptionHeadTr.vue';
import OrderTr from '@/admin/modules/Delivery/_components/OrderTr.vue';
import { get, post, put } from '@/admin/services/api/http-utils';
import AirDatepicker from '@/admin/components/AirDatepicker.vue';
import PartPaid from '@/admin/components/modals/PartPaid.vue';
import UndeliveredOrdersByDateAndTour from '@/admin/modules/Delivery/_components/UndeliveredOrdersByDateAndTour.vue';

const url = `${process.env.VUE_APP_API_HOST}admin/delivery`;
const type = 'partner';

export default {
  components: {
    DatePicker,
    PartnerDelivery,
    VueBarcode,
    ReceptionHeadTr,
    OrderTr,
    AirDatepicker,
    UndeliveredOrdersByDateAndTour,
  },
  props: {
    withoutNS: Boolean,
    time: String,
    panelUserId: [String, Number],
    allowPrinting: Boolean,
    allowMarking: Boolean,
  },
  data() {
    return {
      undeliveredOrdersByDateAndTour: [],
      orderList: [],
      orderListGroupByPoint: [],
      statuses: [],
      sferaNumber: '',
      courier: {},
      summaries: [],
      allIsDelivered: null,
      allIsPaid: null,
      allIsPassed: null,
      allIsBilled: null,
      checkAll: false,
      checkedOrders: [],
      allPassedDate: null,
      allPaidDate: null,
      ordersByTypes: {},
      totalOrdersByTypes: {
        Summary: 0,
        TotalCount: 0,
      },
      currentDeliveryDate: null,
      momentFormat: {
        // Date to String
        stringify: date => (date ? moment(date)
          .format('DD-MM-YYYY') : ''),
        // String to Date
        parse: value => (value ? moment(value, 'DD-MM-YYYY')
          .toDate() : null),
      },
      pointDebt: [],
    };
  },
  // async created() {
  //
  //   // this.fetchCourier();
  //   // this.calcAll();
  // },
  async mounted() {
    this.fetchCourier();
    await this.fetchDebtByTourId();
    await this.fetchStatuses();
    await this.fetchUndeliveredOrdersByDateAndTour();
    this.currentDeliveryDate = this.$route.query.time;
  },
  watch: {
    async withoutNS() {
      await this.fetchDebtByTourId();
    },
    orderList() {
      if (this.orderList) {
        let arr = _.groupBy(this.orderList, 'Point.Id');
        arr = _.sortBy(arr, x => _.head(x).Tour.Name);
        // arr = _.sortBy(arr, x => _.deburr(_.head(x).Point.Reception));
        arr = arr.sort((a, b) => _.head(a).Point.Reception.localeCompare(_.head(b).Point.Reception));// _.sortBy(arr, x => _.deburr(_.head(x).Point.Reception));
        // arr = _.map(arr, x => _.orderBy(x, ['Point.Reception'], ['desc']));
        this.orderListGroupByPoint = arr;

        const olByProductTypeName = _.groupBy(this.orderList, 'Order.ProductTypeName');
        const formatted = {};
        this.totalOrdersByTypes.Summary = 0;
        this.totalOrdersByTypes.TotalCount = 0;
        this.totalOrdersByTypes.TotalAmount = 0;
        _.each(olByProductTypeName, (col, index) => {
          const Summary = _.sumBy(col, 'Order.Summary');
          const Amount = _.sumBy(col, 'Order.Amount');
          formatted[index] = {
            Summary,
            TotalCount: col.length,
            Amount,
          };
          this.totalOrdersByTypes.Summary += Summary;
          this.totalOrdersByTypes.TotalCount += col.length;
          this.totalOrdersByTypes.TotalAmount += Amount;
        });
        this.ordersByTypes = formatted;
      } else {
        this.orderListGroupByPoint = [];
        this.ordersByTypes = [];
      }
    },
    checkAll(newVal) {
      console.log(newVal);
      if (newVal) {
        this.checkedOrders = _.map(this.orderList, o => o.Order.Id);
      } else {
        this.checkedOrders = [];
      }
    },
    // orders() {
    //   this.calcAll();
    // },
  },
  computed: {
    // ordersByType() {
    //   if (this.orderList) {
    //     const arr = _.groupBy(this.orderList, 'Order.ProductTypeName');
    //     const formatted = [];
    //     _.each(arr, (col, index) => {
    //       formatted[index] = _.sumBy(col, 'Order.Summary');
    //     });
    //     return formatted;
    //   }
    //   return null;
    // },
    totalAmount() {
      const totalAmount = {};
      _.each(this.$root.paymentTypes, (val) => {
        totalAmount[val.Id] = _.sumBy(this.orderList, (o) => {
          if (o.Order.PaymentTypeId === val.Id) {
            return o.Order.Summary;
          }
        });
      });
      return totalAmount;
    },
    totalWithPassedDate() {
      let totalAmount = 0;
      _.each(this.orderList, (o) => {
        if (o.Order.PassedDate) {
          totalAmount += o.Order.Summary;
        }
      });
      return totalAmount;
    },
    totalWithPaidDate() {
      let totalAmount = 0;
      _.each(this.orderList, (o) => {
        if (o.Order.PaidDate) {
          totalAmount += o.Order.Summary;
        }
      });
      return totalAmount;
    },
    allowedStatuses() {
      return _.filter(this.statuses, o => _.includes(['in_dispatch', 'delivered'], o.Code));
    },
    allChecked() {
      return this.orderList.length === this.checkedOrders.length;
    },
    // customerOrders() {
    //   return _.groupBy(this.orders, order => order.order.CustomerId);
    // },
    courierBarCode() {
      return `cd_${this.$route.query.panelUserId}_${moment(String(this.$route.query.time))
        .unix()}`;
    },
    currentDate() {
      return moment()
        .format('DD-MM-YYYY, h:mm:ss');
    },
    existTourIds() {
      if (!this.orderList) {
        return [];
      }

      return _.uniq(_.map(this.orderList, 'Tour.Id'));
    },
    isUndeliveredOrdersByDateAndTour() {
      if (!this.undeliveredOrdersByDateAndTour) {
        return false;
      }
      return _.values(this.undeliveredOrdersByDateAndTour).length;
    },
  },
  methods: {
    async setDeliveryDate(date) {
      // console.log(date)
      const orderIds = _.map(this.orderList, (o) => {
        return o.Order.Id
      });
      // if (!confirm('Подтвердите действие')) return;
      await put(`${process.env.VUE_APP_API_HOST}admin/order/update-delivery-date`, { orderIds, date });
      this.$toasted.show('Выполнено', { type: 'success' });
      // await this.fetchDebtByTourId();
    },
    getReceptionSummary(reception) {
      return _.sumBy(reception, 'Order.Summary');
    },
    async setPassedDate(orderItemIds, date) {
      // if (!confirm('Подтвердите действие')) return;
      await put(`${process.env.VUE_APP_API_HOST}admin/order/set-passed-date`, { orderItemIds, date });
      this.$toasted.show('Выполнено', { type: 'success' });
      await this.fetchDebtByTourId();
    },
    async fetchUndeliveredOrdersByDateAndTour() {
      // if (!confirm('Подтвердите действие')) return;
      const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/delivery/undelivered-orders-date-tour/${this.$props.time}/${this.existTourIds.join(',')}`);
      this.undeliveredOrdersByDateAndTour = data;
    },
    async deleteDelivery(DeliveryIds) {
      // if (!confirm('Подтвердите действие')) return;
      console.log(DeliveryIds);
      // return;
      await post(`${process.env.VUE_APP_API_HOST}admin/delivery/delete`, { DeliveryIds });
      this.$toasted.show('Выполнено', { type: 'success' });
      await this.fetchDebtByTourId();
    },
    async setCurrentPassedDate(orderItemIds) {
      this.setPassedDate(orderItemIds, (new Date()).getTime() / 1000);
    },

    async setPaidDate(orderItemIds, date) {
      // if (!confirm('Подтвердите действие')) return;
      const { data } = await put(`${process.env.VUE_APP_API_HOST}admin/order/set-paid-date`, { orderItemIds, date });
      this.$toasted.show('Выполнено', { type: 'success' });
      await this.fetchDebtByTourId();
    },
    async setDeliveryPaidDate(orderItemIds) {
      const deliveryDate = _.head(this.orderList).Delivery.DeliveryDate;
      this.setPaidDate(orderItemIds, deliveryDate);
    },

    async setStatus(orderItemIds, statusCode) {
      // if (!confirm('Подтвердите действие')) return;
      await put(`${process.env.VUE_APP_API_HOST}admin/order/set-status`, { orderItemIds, statusCode });
      this.$toasted.show('Выполнено', { type: 'success' });
      await this.fetchDebtByTourId();
    },

    async setBilledStatus(orderItemIds, billedStatus) {
      // if (!confirm('Подтвердите действие')) return;
      await put(`${process.env.VUE_APP_API_HOST}admin/order/set-billed-status`, { orderItemIds, billedStatus });
      this.$toasted.show('Выполнено', { type: 'success' });
      await this.fetchDebtByTourId();
    },
    async fetchStatuses() {
      const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/order-status`);
      this.statuses = data.data;// _.filter(data.data, o => _.includes(['in_dispatch', 'delivered'], o.Code));
    },

    partPaid(orderItemId) {
      const that = this;
      this.$modal.show(PartPaid, {
        orderItemId,
      }, {
        pivotY: 0.2,
        adaptive: true,
        height: 'auto',
      }, {
        'before-close': function () {
          that.fetchDebtByTourId();
        },
      });
    },

    async fetchDebtByTourId() {
      console.log(this.$props.withoutNS);
      this.orderList = [];
      let query = Object.assign({}, this.$props);
      if (this.$props.withoutNS) {
        query = Object.assign({}, query, { withoutPaymentTypes: ['НС'] });
      }
      const { data } = await get(`${url}/by-time-and-panel-user/${type}`, query);
      this.orderList = data;
      this.fetchPointDebt();
    },
    async checkOrderItemIsCardPaid(orderItem) {
      console.log(orderItem);
      const { data } = await get(`${url}/check-is-card/${orderItem.Id}`);
      console.log(data);
      orderItem.IsCardPaid = data;
    },
    async fetchPointDebt() {
      const pointIds = _.map(this.orderList, o => o.Point.Id);
      const { data } = await get(`${url}/point-debt/${pointIds.join(',')}`);
      this.pointDebt = data;
    },
    async print() {
      await this.$htmlToPaper('printMe');
    },
    async print2() {
      await this.$htmlToPaper('printMe2');
    },
    async fetchCourier() {
      const { data } = await get(`${url}/couriers/${this.$route.query.panelUserId}`);
      this.courier = data;
    },
    checkByPointId(event, PointId) {
      const value = event.target.checked;
      const orders = _.filter(this.orderList, o => o.Point.Id === PointId);
      const orderIds = _.map(orders, o => o.Order.Id);
      // console.log('orderIds', orderIds);
      let merged = [];
      if (value) {
        merged.push(...this.checkedOrders);
        merged.push(...orderIds);
        merged = _.uniq(merged);
        this.checkedOrders = merged;
      } else {
        this.checkedOrders = _.filter(this.checkedOrders, id => !_.includes(orderIds, id));
      }

      // console.log(event.target.checked, PointId);
    },
    fullFilledPoint(PointId) {
      const orders = _.filter(this.orderList, o => o.Point.Id === PointId);
      const orderIds = _.map(orders, o => o.Order.Id);
      return !_.difference(orderIds, this.checkedOrders).length;
    },
    getStatusNameById(statusId) {
      // console.log(this.statuses, statusId)
      const status = _.find(this.statuses, o => o.Id === statusId);
      // console.log(status)
      return status ? status.Name : '';
      // return status.Name;
    },
    statusColor(statusId) {
      const status = _.find(this.statuses, o => o.Id === statusId);
      if (status && status.Code === 'in_dispatch') {
        return 'btn-danger';
      }
      if (status && status.Code === 'delivered') {
        return 'btn-success';
      }
      return 'btn-outline-info';
    },
    billedStatusColor(isBilled) {
      if (isBilled) {
        return 'btn-success';
      }
      return 'btn-danger';
    },
    pointBarCode(Point) {
      return `pd_${Point.Id}_${moment(String(this.$route.query.time))
        .unix()}`;
    },
    // async addOrder() {
    //   try {
    //     const { data } = await get(`${url}/is-in-delivery/${this.sferaNumber}`);
    //     const appendOrder = async () => {
    //       await post(`${url}/append-order-to-delivery/${this.sferaNumber}`, {
    //         DeliveryDate: this.$route.query.time,
    //         PanelUserId: this.$route.query.panelUserId,
    //       });
    //       this.fetchDelivery();
    //       this.$modal.hide('dialog');
    //     };
    //     if (data) {
    //       this.$modal.show('dialog', {
    //         title: 'Предупреждение',
    //         text: `Заказ ${this.sferaNumber} уже есть в доставке на ${moment(String(data.DeliveryDate))
    //           .format('DD-MM-YYYY hh:mm')}`,
    //         buttons: [
    //           {
    //             title: 'Переназначить текущему пользователю', // Button title
    //             default: true, // Will be triggered by default if 'Enter' pressed.
    //             handler: appendOrder, // Button click handler
    //           },
    //           {
    //             title: 'Закрыть',
    //           },
    //         ],
    //       });
    //     } else {
    //       appendOrder();
    //     }
    //   } catch (error) {
    //     if (error.response && error.response.data) {
    //       this.$toasted.show(error.response.data, { type: 'error' });
    //     } else {
    //       this.$toasted.show('Неизвестная ошибка', { type: 'error' });
    //     }
    //   }
    // },
    // getDeliveryIDs() {
    //   return _.map(this.orders, item => item.delivery.Id);
    // },
    // allToDelivered() {
    //   this.markDeliveries('IsDelivered', this.getDeliveryIDs(), this.allIsDelivered);
    // },
    // allToPaid() {
    //   this.markDeliveries('IsPaid', this.getDeliveryIDs(), this.allIsPaid);
    // },
    // allToPassed() {
    //   this.markDeliveries('IsPassed', this.getDeliveryIDs(), this.allIsPassed);
    // },
    // markDeliveries(PropName, DeliveryIDs, value) {
    //   let titlePropName;
    //   switch (PropName) {
    //     case 'IsDelivered':
    //       titlePropName = 'Доставлены';
    //       break;
    //     case 'IsPaid':
    //       titlePropName = 'Оплачены';
    //       break;
    //     case 'IsPartPaid':
    //       titlePropName = 'Частично оплачены';
    //       break;
    //     case 'IsPassed':
    //       titlePropName = 'Сданы';
    //       break;
    //     default:
    //       titlePropName = null;
    //   }
    //   const mark = async () => {
    //     console.log(!value);
    //     await post(`${url}/mark-deliveries`, {
    //       PropName,
    //       DeliveryIDs,
    //       value: !value,
    //     });
    //     this.fetchDelivery();
    //     this.$modal.hide('dialog');
    //   };
    //   this.$modal.show('dialog', {
    //     title: 'Предупреждение',
    //     text: `Пометить доставки ${titlePropName ? `"${titlePropName}"` : ''}?`,
    //     buttons: [
    //       {
    //         title: 'Да', // Button title
    //         default: true, // Will be triggered by default if 'Enter' pressed.
    //         handler: mark,
    //       },
    //       {
    //         title: 'Отмена',
    //       },
    //     ],
    //   });
    // },
    // async commitPartAmount(data) {
    //   const { DeliveryId, PartAmount } = data;
    //   await put(url, { Id: DeliveryId, PartAmount });
    //   this.fetchDelivery();
    // },
  },
};
</script>
<style lang="scss">
.table-cell-align-middle {
  tr {
    td {
      vertical-align: middle;
    }
  }
}
</style>
